import {
  ChangeDetectorRef,
  Component,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { IComboBase } from '../interfaces/base/base.interface';
import { VacationService } from './services/vacation.service';
import { VacationRequestDTO } from '../interfaces/vacation.interface';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalLoadingComponent } from '../shared/modals/modal-loading/modal-loading.component';
import { ModalSuccessComponent } from '../shared/modals/modal-success/modal-success.component';
import { ModalRejectComponent } from '../shared/modals/modal-reject/modal-reject.component';
import { Router } from '@angular/router';
import { ModalInfoComponent } from './components/modal-info/modal-info.component';
import { TypeVacationService } from '../services/type-vacation.service';
import { EmployeeService } from '../services/employee.service';
import {
  extractFileName,
  getMonthName,
  numberToText,
  getDayLabel,
} from '../utils/helpers';

@Component({
  selector: 'app-vacation',
  templateUrl: './vacation.component.html',
  styleUrls: ['./vacation.component.scss'],
})
export class VacationComponent {
  userData: any = null;
  employeeData: any;
  startDate: Date | null = null;
  endDate: Date | null = null;
  minDate: Date | null = null;
  maxStartDate: Date | null = null;
  maxEndDate: Date | null = null;
  tooltipVisible: string | null = null;
  getDayLabel = getDayLabel;

  vacationTypes: IComboBase[] = [];
  selectedOptionKey: string | null = null;

  accumulatedDays: number = 0;
  usedDaysLaw: number = 0;
  accumulatedBonusDays: number = 0;
  usedBonusDays: number = 0;
  selectedVacationType: any;
  filteredVacationTypes: IComboBase[] = [];

  totalDays: number = 0;
  currentFile: File | null = null;
  downloadUrl: string | null = null;
  documentGenerated: boolean = false;
  documentUpload: boolean = false;

  // transferableDays = Math.max(0, this.accumulatedDays - this.totalDays);

  @ViewChild('pdfUploader') pdfUploader: any;
  selectedFileName: string | null = null;
  selectedFileUploadName: string | null = null;

  startDateEmployee: Date | null = null;

  selectedDates: Date[] = [];
  messageCollaborator = '';
  confirmationChecked = false;

  isDisabled: boolean = true;

  constructor(
    private vacationService: VacationService,
    private employeeService: EmployeeService,
    private typeVacationService: TypeVacationService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.resetForm();
    this.loadEmployeeData();

    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }

    this.typeVacationService.comboTypeVacation().subscribe({
      next: (data) => {
        this.vacationTypes = data;
        this.filterVacationTypesBasedOnSeniority();
      },

      error: (err) => {
        console.error('Error al obtener la lista de tipos de vacaciones:', err);
      },
    });
  }

  ngAfterViewInit(): void {
    this.loadEmployeeData();
  }

  loadEmployeeData(): void {
    this.employeeService.employeeData$.subscribe((data) => {
      if (data != null) {
        this.employeeData = data;
        console.log('this.employeeData ', this.employeeData);

        if (this.employeeData && this.employeeData.startDate) {
          const [day, month, year] = this.employeeData.startDate.split('/');
          this.startDateEmployee = new Date(`${year}-${month}-${day}`);
          this.filterVacationTypesBasedOnSeniority();

          this.accumulatedDays = this.employeeData.accumulatedDays;
          this.accumulatedBonusDays = this.employeeData.accumulatedBonusDays;
          this.usedBonusDays = this.employeeData.usedBonusDays;
          this.usedDaysLaw = this.employeeData.usedDays;

          console.log(
            'datos: ',
            this.accumulatedDays,
            this.accumulatedBonusDays,
            this.usedBonusDays,
            this.usedDaysLaw
          );
        } else {
          console.error('employeeData o startDate es null o undefined');
        }
        this.cdr.detectChanges();
      }
    });
  }
  validateForm() {
    const isType4 = this.selectedVacationType?.key == '4';

    this.isDisabled = !(
      this.selectedVacationType &&
      this.startDate &&
      this.endDate &&
      (!isType4 || (isType4 && this.downloadUrl && this.currentFile)) &&
      this.confirmationChecked
    );

    console.log('VALIDACION: ', this.isDisabled);
  }

  filterVacationTypes(event: any): void {
    const query = event.query.toLowerCase();
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    this.filteredVacationTypes = this.vacationTypes.filter(
      (option) =>
        option.text.toLowerCase().includes(query) &&
        (this.startDateEmployee &&
        this.startDateEmployee.getTime() <= oneYearAgo.getTime()
          ? true
          : option.key == '1' || option.key == '4')
    );
  }

  filterVacationTypesBasedOnSeniority(): void {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    if (
      this.startDateEmployee &&
      this.startDateEmployee.getTime() <= oneYearAgo.getTime()
    ) {
      this.filteredVacationTypes = this.vacationTypes;
    } else {
      this.filteredVacationTypes = this.vacationTypes.filter(
        (type) => type.key == '1' || type.key == '4'
      );
    }
  }

  onChangeInput(event: any): void {
    this.selectedVacationType = null;
  }

  onSelect(event: any): void {
    this.selectedVacationType = event.value ?? null;
    this.selectedOptionKey = this.selectedVacationType?.key || null;
    this.resetDocumentState();

    if (this.startDate) {
      if (this.selectedVacationType?.key != '4') {
        this.maxEndDate = new Date(this.startDate);
        this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
      } else {
        this.maxEndDate = null;
      }
    }

    if (this.selectedDates.length > 0) {
      this.selectedDates = [this.selectedDates[0]];
      this.endDate = null;
      this.onRangeSelect();
    }
    console.log('Tipo de vacaciones seleccionada:', this.selectedOptionKey);
    this.validateForm();
  }

  // Actualiza el rango de fechas al cambiar individualmente las fechas de inicio o fin
  updateRange(): void {
    if (this.startDate && this.endDate) {
      this.selectedDates = [this.startDate, this.endDate];
    } else {
      this.selectedDates = [];
    }
  }

  openTooltipModal(title: string, description: string) {
    this.dialogService.open(ModalInfoComponent, {
      closable: false,
      width: '300px',
      data: {
        title: title,
        description: description,
      },
    });
  }

  calculateTotalDays(): void {
    if (this.startDate && this.endDate) {
      const start = this.startDate;
      const end = this.endDate;

      const diffInDays =
        (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24) + 1;

      this.totalDays = diffInDays > 0 ? Math.round(diffInDays) : 0;
    } else {
      this.totalDays = 0;
    }
  }

  onRegister() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    const solicitudeCode = `VACATION-${randomNumber}`;
    const stateId = this.selectedVacationType?.key == '4' ? '2' : '1';

    const request: VacationRequestDTO = {
      companyId: this.userData?.companyId,
      employeeId: this.userData?.employeeId,
      solicitudeCode: solicitudeCode,
      typeVacationId: this.selectedVacationType.key,
      breakStartDate: this.startDate!.toISOString().split('.')[0],
      breakEndDate: this.endDate!.toISOString().split('.')[0],
      detailMessageCollaborator: this.messageCollaborator,
      stateSolicitudeId: stateId,
    };

    const formData = new FormData();

    formData.append('companyId', request.companyId!);
    formData.append('employeeId', request.employeeId!);
    formData.append('solicitudeCode', request.solicitudeCode);
    formData.append('typeVacationId', request.typeVacationId!);
    formData.append('breakStartDate', request.breakStartDate!);
    formData.append('breakEndDate', request.breakEndDate!);
    formData.append('stateSolicitudeId', request.stateSolicitudeId);
    formData.append(
      'detailMessageCollaborator',
      request.detailMessageCollaborator!
    );

    // Agregar archivo solo si es tipo 4 (Adelanto de Vacaciones)
    if (this.selectedVacationType?.key == '4' && this.currentFile) {
      formData.append('file', this.currentFile);
    }

    this.vacationService.createVacation(formData).subscribe({
      next: (response: any) => {
        loadingRef.close();
        const successMessage = response.message;
        const ref = this.dialogService.open(ModalSuccessComponent, {
          closable: true,
          data: {
            text: successMessage,
            title: '¡Solicitud enviada!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Ver solicitudes',
            buttonAction: () => {
              this.navigateToSolicitudes();
            },
          },
        });
        // console.log('response', successMessage);
        this.resetForm();
        this.loadEmployeeData();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          closable: true,
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
          },
        });
        this.resetForm();
      },
    });
  }

  navigateToSolicitudes() {
    this.router.navigate(['/dashboard/solicitude']);
  }

  resetForm() {
    this.selectedVacationType = null;
    this.startDate = null;
    this.endDate = null;
    this.confirmationChecked = false;
    this.messageCollaborator = '';

    this.selectedDates = [];
    this.selectedOptionKey = null;

    this.validateForm();
  }

  onStartDateChange(selectedStartDate: Date): void {
    if (selectedStartDate) {
      this.startDate = selectedStartDate;
      this.resetDocumentState();

      if (this.selectedVacationType?.key != '4') {
        this.maxEndDate = new Date(selectedStartDate);
        this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
      } else {
        this.maxEndDate = null;
      }

      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = null;
      }

      this.syncSelectedDates();
      this.calculateTotalDays();
    } else {
      this.maxEndDate = null;
      this.resetDocumentState();
    }
  }

  onEndDateChange(selectedEndDate: Date): void {
    if (selectedEndDate) {
      this.resetDocumentState();

      if (this.startDate && selectedEndDate < this.startDate) {
        this.endDate = null;
      } else {
        this.endDate = selectedEndDate;
      }

      this.syncSelectedDates();
      this.calculateTotalDays();
    }
    this.validateForm();
    this.resetDocumentState();
  }

  onRangeSelect(): void {
    if (Array.isArray(this.selectedDates) && this.selectedDates.length === 2) {
      this.resetDocumentState();

      this.startDate = this.selectedDates[0];
      this.endDate = this.selectedDates[1];
      if (this.startDate) {
        if (String(this.selectedVacationType?.key) != '4') {
          this.maxEndDate = new Date(this.startDate);
          this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
        } else {
          this.maxEndDate = null;
        }
      } else {
        this.maxEndDate = null;
      }
    }
    this.calculateTotalDays();
    this.validateForm();
    this.resetDocumentState();
  }

  syncSelectedDates(): void {
    if (this.startDate && this.endDate) {
      this.selectedDates = [this.startDate, this.endDate];
    } else {
      this.selectedDates = [];
    }
  }

  onDragOver(event: DragEvent) {
    if (!this.documentUpload) return;

    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'copy';
  }

  onDragLeave(event: DragEvent) {
    if (!this.documentUpload) return;

    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    if (!this.documentUpload) return;

    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0];

      if (this.isValidFile(droppedFile)) {
        this.currentFile = droppedFile;
        this.selectedFileUploadName = droppedFile.name;
        console.log('this.selectedFileUploadName', this.selectedFileUploadName);

        this.validateForm();
      } else {
        this.currentFile = null;
        this.selectedFileUploadName = null;
        this.validateForm();

        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF, DOC o DOCX de hasta 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
      }
    }
  }

  isValidFile(file: File): boolean {
    const allowedExtensions = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
    const maxSize = 10 * 1024 * 1024;

    if (!allowedExtensions.includes(file.type)) {
      console.log('Tipo de archivo no permitido:', file.type);
      return false;
    }

    if (file.size > maxSize) {
      console.log('Archivo demasiado grande:', file.size);
      return false;
    }

    return true;
  }

  onChangeFile(event: any) {
    const selectedFile = event.files[0];
    if (selectedFile) {
      const maxSize = 10 * 1024 * 1024;
      const allowedTypes = ['application/pdf'];

      if (!allowedTypes.includes(selectedFile.type)) {
        this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        return;
      }

      if (selectedFile.size > maxSize) {
        this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo es demasiado grande. El tamaño máximo permitido es de 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        return;
      }

      this.currentFile = selectedFile;
      this.selectedFileUploadName = selectedFile.name;
      this.validateForm();
    }
  }

  openFileUpload(type: string) {
    if (!this.documentUpload) return;

    if (type === 'pdf' && this.pdfUploader) {
      this.pdfUploader.choose();
    } else {
      console.error('El fileUploader no está disponible.');
    }
  }

  // Generar PDF
  onDownload() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const formattedDates = this.getFormattedDates();

    const request = {
      companyId: this.userData?.companyId,
      employeeId: this.userData?.employeeId,
      days: this.totalDays,
      daysName: numberToText(this.totalDays),
      dayStartDate: formattedDates?.startDate.day,
      monthNameStartDate: formattedDates?.startDate.month,
      yearStartDate: formattedDates?.startDate.year,
      dayEndDate: formattedDates?.endDate.day,
      monthNameEndDate: formattedDates?.endDate.month,
      yearEndDate: formattedDates?.endDate.year,
    };

    this.vacationService.postGeneratePDF(request).subscribe({
      next: (response) => {
        loadingRef.close();
        this.downloadUrl = response.solicitudePdfUrl;
        this.documentGenerated = true;
        this.documentUpload = true;
        this.selectedFileName = extractFileName(response.solicitudePdfUrl);
        const ref = this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text: 'El documento se ha generado con éxito.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Revisar documento',
            buttonAction: () => this.downloadFile(),
          },
        });
        this.validateForm();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          closable: true,
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.validateForm();
        console.error('Error al generar pdf:', err);
      },
    });
    // this.closeDialog();
  }

  // Descargar PDF
  downloadFile() {
    if (!this.downloadUrl) return;

    const link = document.createElement('a');
    link.href = this.downloadUrl;
    link.target = '_blank';
    link.download = this.downloadUrl.split('/').pop() || 'documento.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  resetDocumentState() {
    this.documentGenerated = false;
    this.downloadUrl = null;
    this.currentFile = null;
    this.selectedFileName = null;
    this.selectedFileUploadName = null;
  }

  // Formateando fechas
  getFormattedDates() {
    if (!this.startDate || !this.endDate) return null;

    const startDay = this.startDate.getDate();
    const startMonth = this.startDate.getMonth() + 1;
    const startYear = this.startDate.getFullYear();

    const endDay = this.endDate.getDate();
    const endMonth = this.endDate.getMonth() + 1;
    const endYear = this.endDate.getFullYear();

    return {
      startDate: {
        day: startDay,
        month: getMonthName(startMonth),
        year: startYear,
      },
      endDate: {
        day: endDay,
        month: getMonthName(endMonth),
        year: endYear,
      },
    };
  }

  shouldDisableDownloadButton(): boolean {
    if (this.selectedVacationType?.key === '4') {
      return false;
    }

    return !this.startDate || !this.endDate;
  }
}
